import React, { Fragment } from "react";
export const OpacityOverlay = ({ children, on }) => {
    return (React.createElement(Fragment, null, on ? (React.createElement(Fragment, null,
        React.createElement("div", { className: "opacity-overlay" }),
        React.createElement("div", { className: "opacity-overlay--content" }, children))) : (children)));
};
